import { DatalayerHelper } from './ib-datalayer-helper';
import * as ancillariesInfo   from '../core/models/ancillaries-info';

@Service('ib-web-ancillaries-module',
    ['CommonsUtilService', 'DatalayerHelper', 'localStorageService'],
    ['ib-commons-constants-module', 'ib-monetate-module'])
export class FlexibilizationDatalayerUtils {
    seatSelectedId: string[] = [];
    seatSelectedType: string[] = [];
    segmentId: string;
    constructor (
        private CommonsUtilService: CommonsUtilService,
        private DatalayerHelper: DatalayerHelper,
        private localStorageService: angular.local.storage.ILocalStorageService
    ) { }


    getFlex = (flex): number => flex.total;
    getFlexItemVariant = (flex): string => flex.description.toLowerCase();
    getFlexItemBrand = (selectedTripInfo, id): string => selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(id, null);

    getFlexItem = ({offer, ancillaryType = 'flexible_ticket'}) => {
        const id = this.CommonsUtilService.getIdItem('all');
        const selectedTripInfo: any = this.localStorageService.get('selectedTripInfo');
        const item: DigitalDataEcommerceModel.Item = {
            item_name: ancillaryType,
            item_id: id,
            price: offer.total,
            item_brand: selectedTripInfo ? selectedTripInfo[0].info.segments[0].flight.operationalCarrier.name.toLowerCase() : this.DatalayerHelper.getBrandItem(id, null),
            item_category: this.DatalayerHelper.getItemCategory(),
            item_category2: 'all',
            item_category3: 'all',
            item_variant: this.getFlexItemVariant(offer)
        };
        return item;
    };
    getDataEcommerceForFlexibilization (ancillaryType: string, offer ) {
        return this.getFlexItem({offer, ancillaryType});
    }

    setFlexibilizationSelectItem = (offer: AncillariesModel.AncillaryInfo): DigitalDataEcommerceModel.ViewItemList => {
        const digital_data_ecommerce: DigitalDataEcommerceModel.ViewItemList = { items: [] };
        let item: DigitalDataEcommerceModel.Item = this.getFlexItem({offer, ancillaryType: 'flexible_ticket'});
        item = {...item, quantity: 1};
        digital_data_ecommerce.items.push(item);
        return digital_data_ecommerce;
    };
}

